const Copy = ({ color, type }) => {
  const solid = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 4.8335H4C2.897 4.8335 2 5.7305 2 6.8335V8.8335H22V6.8335C22 5.7305 21.103 4.8335 20 4.8335ZM2 18.8335C2 19.9365 2.897 20.8335 4 20.8335H20C21.103 20.8335 22 19.9365 22 18.8335V12.8335H2V18.8335ZM5 15.8335H11V17.8335H5V15.8335Z"
        fill={color}
      />
    </svg>
  );
  const regular = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 4.8335H4C2.897 4.8335 2 5.7305 2 6.8335V18.8335C2 19.9365 2.897 20.8335 4 20.8335H20C21.103 20.8335 22 19.9365 22 18.8335V6.8335C22 5.7305 21.103 4.8335 20 4.8335ZM4 6.8335H20V8.8335H4V6.8335ZM4 18.8335V12.8335H20.001L20.002 18.8335H4Z"
        fill={color}
      />
      <path d="M6 14.8335H12V16.8335H6V14.8335Z" fill={color} />
    </svg>
  );
  const getSVGByType = (type) => {
    switch (type) {
      case "solid":
        return solid;
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Copy;
